const menu = {

  f2m012: { 
    tipo: "Entrantes",
    key: "f2m012",
    titleCh: "饺蔬菜", 
    titleEs: "Gyoza",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_1.jpg",
    roundImage:"/static/img/nh/menu/1.jpg",
  },
  "32423egfe": { 
    tipo: "Entrantes",
    key: "32423egfe",
    titleCh: "素食主义者", 
    titleEs: "Tosta vegana",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_2.jpg",
    roundImage:"/static/img/nh/menu/2.jpg",
  },
  "76446dfsf": { 
    tipo: "Entrantes",
    key: "76446dfsf",
    titleCh: "三文鱼和鳄梨沙拉", 
    titleEs: "Ensalada de salmón y aguacate",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_3.jpg",
    roundImage:"/static/img/nh/menu/3.jpg",
  },
  "432432hggh": { 
    tipo: "Entrantes",
    key: "432432hggh",
    titleCh: "奎奴亚藜和石榴沙拉", 
    titleEs: "Ensalada de quinoa y granada",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_4.jpg",
    roundImage:"/static/img/nh/menu/4.jpg",
  },
  sadaouio: { 
    tipo: "Entrantes",
    key: "sadaouio",
    titleCh: "伊比利亚火腿", 
    titleEs: "Jamón ibérico",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_5.jpg",
    roundImage:"/static/img/nh/menu/5.jpg",
  },
  mn435: { 
    tipo: "Entrantes",
    key: "mn435",
    titleCh: "区域奶酪", 
    titleEs: "Quesos regionales",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/entrantes_6.jpg",
    roundImage:"/static/img/nh/menu/6.jpg",
  },
  ghtyhb: { 
    tipo: "Primeros",
    key: "ghtyhb",
    titleCh: "饺蔬菜", 
    titleEs: "Gyoza",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_1.jpg",
    roundImage:"/static/img/nh/menu/1.jpg",
  },
  cvxvxeew: { 
    tipo: "Primeros",
    key: "cvxvxeew",
    titleCh: "素食主义者", 
    titleEs: "Tosta vegana",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_2.jpg",
    roundImage:"/static/img/nh/menu/2.jpg",
  },
  khjk768: { 
    tipo: "Primeros",
    key: "khjk768",
    titleCh: "三文鱼和鳄梨沙拉", 
    titleEs: "Ensalada de salmón y aguacate",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_3.jpg",
    roundImage:"/static/img/nh/menu/3.jpg",
  },
  nbvnb3453: { 
    tipo: "Primeros",
    key: "nbvnb3453",
    titleCh: "奎奴亚藜和石榴沙拉", 
    titleEs: "Ensalada de quinoa y granada",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_4.jpg",
    roundImage:"/static/img/nh/menu/4.jpg",
  },
  adas7868: { 
    tipo: "Primeros",
    key: "adas7868",
    titleCh: "伊比利亚火腿", 
    titleEs: "Jamón ibérico",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_5.jpg",
    roundImage:"/static/img/nh/menu/5.jpg",
  },
  ds453353: { 
    tipo: "Primeros",
    key: "ds453353",
    titleCh: "区域奶酪", 
    titleEs: "Quesos regionales",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/primeros_6.jpg",
    roundImage:"/static/img/nh/menu/6.jpg",
  },
  fdsfs32423: { 
    tipo: "Pescados",
    key: "fdsfs32423",
    titleCh: "饺蔬菜", 
    titleEs: "Gyoza",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_1.jpg",
    roundImage:"/static/img/nh/menu/1.jpg",
  },
  rhytr765: { 
    tipo: "Pescados",
    key: "rhytr765",
    titleCh: "素食主义者", 
    titleEs: "Tosta vegana",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_2.jpg",
    roundImage:"/static/img/nh/menu/2.jpg",
  },
  jgj43: { 
    tipo: "Pescados",
    key: "jgj43",
    titleCh: "三文鱼和鳄梨沙拉", 
    titleEs: "Ensalada de salmón y aguacate",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_3.jpg",
    roundImage:"/static/img/nh/menu/3.jpg",
  },
  klij678: { 
    tipo: "Pescados",
    key: "klij678",
    titleCh: "奎奴亚藜和石榴沙拉", 
    titleEs: "Ensalada de quinoa y granada",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_4.jpg",
    roundImage:"/static/img/nh/menu/4.jpg",
  },
  wew: { 
    tipo: "Pescados",
    key: "wew",
    titleCh: "伊比利亚火腿", 
    titleEs: "Jamón ibérico",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_5.jpg",
    roundImage:"/static/img/nh/menu/5.jpg",
  },
  yr765: { 
    tipo: "Pescados",
    key: "yr765",
    titleCh: "区域奶酪", 
    titleEs: "Quesos regionales",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/pescados_6.jpg",
    roundImage:"/static/img/nh/menu/6.jpg",
  },
  jghh: { 
    tipo: "Carnes",
    key: "jghh",
    titleCh: "饺蔬菜", 
    titleEs: "Gyoza",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_1.jpg",
    roundImage:"/static/img/nh/menu/1.jpg",
  },
  vsds: { 
    tipo: "Carnes",
    key: "vsds",
    titleCh: "素食主义者", 
    titleEs: "Tosta vegana",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_2.jpg",
    roundImage:"/static/img/nh/menu/2.jpg",
  },
  jgjcvcs43: { 
    tipo: "Carnes",
    key: "jgjcvcs43",
    titleCh: "三文鱼和鳄梨沙拉", 
    titleEs: "Ensalada de salmón y aguacate",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_3.jpg",
    roundImage:"/static/img/nh/menu/3.jpg",
  },
  hjgc: { 
    tipo: "Carnes",
    key: "hjgc",
    titleCh: "奎奴亚藜和石榴沙拉", 
    titleEs: "Ensalada de quinoa y granada",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_4.jpg",
    roundImage:"/static/img/nh/menu/4.jpg",
  },
  qwefd: { 
    tipo: "Carnes",
    key: "qwefd",
    titleCh: "伊比利亚火腿", 
    titleEs: "Jamón ibérico",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_5.jpg",
    roundImage:"/static/img/nh/menu/5.jpg",
  },
  hjgj75: { 
    tipo: "Carnes",
    key: "hjgj75",
    titleCh: "区域奶酪", 
    titleEs: "Quesos regionales",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/carnes_6.jpg",
    roundImage:"/static/img/nh/menu/6.jpg",
  },
  gdfgdg: { 
    tipo: "Postres",
    key: "gdfgdg",
    titleCh: "饺蔬菜", 
    titleEs: "Gyoza",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_1.jpg",
    roundImage:"/static/img/nh/menu/1.jpg",
  },
  vsdfsdfss: { 
    tipo: "Postres",
    key: "vsdfsdfss",
    titleCh: "素食主义者", 
    titleEs: "Tosta vegana",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_2.jpg",
    roundImage:"/static/img/nh/menu/2.jpg",
  },
  jgjcv5cs43: { 
    tipo: "Postres",
    key: "jgjcv5cs43",
    titleCh: "三文鱼和鳄梨沙拉", 
    titleEs: "Ensalada de salmón y aguacate",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_3.jpg",
    roundImage:"/static/img/nh/menu/3.jpg",
  },
  hjg5c: { 
    tipo: "Postres",
    key: "hjg5c",
    titleCh: "奎奴亚藜和石榴沙拉", 
    titleEs: "Ensalada de quinoa y granada",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_4.jpg",
    roundImage:"/static/img/nh/menu/4.jpg",
  },
  qw5efd: { 
    tipo: "Postres",
    key: "qw5efd",
    titleCh: "伊比利亚火腿", 
    titleEs: "Jamón ibérico",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_5.jpg",
    roundImage:"/static/img/nh/menu/5.jpg",
  },
  hjgj575: { 
    tipo: "Postres",
    key: "hjgj575",
    titleCh: "区域奶酪", 
    titleEs: "Quesos regionales",
    price: "25",
    mainImage:"/static/img/nh/menu/platos/postres_6.jpg",
    roundImage:"/static/img/nh/menu/6.jpg",
  },
  
}

export default menu


// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/hotelMenuSection.js